<template>
  <div>
    <fieldset>
      <legend>{{ legend }}</legend>
      <slot />
    </fieldset>
  </div>
</template>

<script>
export default {
  name: 'Fieldset',
  props: {
    legend: String
  }
}
</script>

<style scoped>
fieldset {
  border: 1px solid #777;
  margin-inline-start: 0px;
  padding-inline-start: 4px;
  padding-block-start: 0px;
  padding-block-end: 4px;
}
</style>
